/**
 * Vocabulary shared by every analytics summary bar, whatever the section.
 *
 * `thisPeriod` is the tail of a movement line — "↗ 5 This Period". It is one
 * fixed phrase rather than one chosen from the Reporting Period filter: the
 * wording used to vary ("this month" under all time, "this period" once a
 * period was chosen) and the distinction cost a hook, a test and a branch at
 * every call site to express something the reader does not act on.
 *
 * Under all time the figure behind it is a month-over-month move, so the phrase
 * names a wider window than the number covers. Accepted deliberately.
 */
export const textAnalytics = {
    pastMonth: "Past Month",
    thisPeriod: "This Period"
};
